import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import {setNativeTitleWithNavigation, closeButton, getValuesFromUserAgent, nativeBackAction,versionCompare,nativeHideTopBar,updateTab} from "../../actions/native";
/*ER PDF page with close button*/
/*updateTab - true - hide bottom nav in oneapp*/
/*new bridge functions to be reviewed*/
class EquipmentReturnPDF extends React.Component {

    constructor(props) {
        super(props);
        this.isValidUser = false;
        if(window.userinfo !== null) {this.isValidUser = true;}
    }

    componentDidMount(){
      const { channelId, version } = getValuesFromUserAgent(
        navigator.userAgent
      );
      if (
        (versionCompare(version, "11.1.0") &&
          channelId.toUpperCase() === "VZW-MFA-IOS") ||
        (versionCompare(version, "18.2.0") &&
          channelId.toUpperCase() === "VZW-MFA-ANDROID")
      ) {
        nativeBackAction("Equipment return PDF",true, true, true);
      } else {
        setNativeTitleWithNavigation("Equipment return PDF", true, true);
        nativeHideTopBar(true);
        updateTab(true);
      }
    }
    render(){
        const PDFContent = localStorage.getItem('PDFContent');
        return(
            <div>
               {ReactHtmlParser(PDFContent)}
            </div>
        );
    }
}

export default EquipmentReturnPDF



// WEBPACK FOOTER //
// ./src/components/modules/EquipmentReturnPDF.js